<template>
  <el-dialog
      width="60%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title="$t('admin.holidayPeriods.editHolidayPeriod')"
      class="dialog-with-cols"
  >
    <el-form :model="editForm" :rules="editFormRules" label-position="top" ref="editForm" size="mini">
      <el-row>
        <el-col :md="16" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.holidayPeriods.name')" prop="name" ref="name" class="inline-input">
            <el-input
                v-model="editForm.name"
                maxlength="255"
                class="inline-input"
                id="addForm-name"
                disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.holidayPeriods.regions')" prop="regionIds" ref="regionIds"
                        class="inline-input">
            <el-select
                v-model="editForm.regionIds"
                multiple
                placeholder="Select regions"
                style="width: 100%">
              <el-option
                  v-for="region in regions"
                  :key="region.id"
                  :label="region.code"
                  :value="region.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.holidayPeriods.effectiveDate')" prop="effectiveDate" ref="effectiveDate"
                        class="inline-input">
            <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                size="mini"
                v-model="editForm.effectiveDate"
                format="MM/dd/yyyy"
                :clearable="false"
                :picker-options="effectiveDateOptions"
                type="date"
                style="width: 100%"
                :disabled="!canEditEffectiveDate"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.holidayPeriods.expirationDate')" prop="expirationDate" ref="expirationDate"
                        class="inline-input">
            <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                size="mini"
                v-model="editForm.expirationDate"
                format="MM/dd/yyyy"
                :clearable="false"
                :picker-options="expirationDateOptions"
                type="date"
                style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.holidayPeriods.earlyAccess')" class="inline-input">
            <el-checkbox v-model="editForm.earlyAccess"></el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="initializeForm" size="mini">{{ $t('common.clear') }}</el-button>
        <el-button type="primary" @click="handleSave" size="mini" :loading="loading">{{ $t('common.save') }}</el-button>
      </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import constants from '@/utils/constants';

export default {
  name: 'EditHolidayPeriod',
  computed: {
    ...mapState({
      regions: state => state.holidayPeriods.regions,
      currentRow: state => state.holidayPeriods.currentRow
    })
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      editForm: {
        id: null,
        name: '',
        effectiveDate: new Date(),
        expirationDate: new Date(),
        regionIds: [],
        earlyAccess: false
      },
      editFormRules: {
        effectiveDate: [
          { required: true, message: this.$t('admin.holidayPeriods.errors.fieldRequired'), trigger: 'change' }
        ],
        expirationDate: [
          { required: true, message: this.$t('admin.holidayPeriods.errors.fieldRequired'), trigger: 'change' }
        ],
        regionIds: [
          {
            required: true,
            message: this.$t('admin.holidayPeriods.errors.fieldRequired'),
            trigger: 'change',
            type: 'array'
          }
        ]
      },
      effectiveDateOptions: {
        disabledDate(date) {
          return moment(date.getTime()).isBefore(Date.now(), 'day');
        }
      },
      expirationDateOptions: {
        disabledDate(date) {
          return moment(date.getTime()).isBefore(Date.now(), 'day');
        }
      }
    };
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
      this.initializeForm();
    },
    initializeForm() {
      this.editForm = {
        id: this.currentRow.id,
        name: this.currentRow.name,
        effectiveDate: this.currentRow.effectiveDate ? moment(this.currentRow.effectiveDate, constants.DATES.DEFAULT_BACKEND_FORMAT).toDate() : null,
        expirationDate: this.currentRow.expirationDate ? moment(this.currentRow.expirationDate, constants.DATES.DEFAULT_BACKEND_FORMAT).toDate() : null,
        regionIds: this.currentRow.regionIds || [],
        earlyAccess: this.currentRow.earlyAccess || false,
      };

      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate();
      }
    },
    handleSave() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          this.$store.dispatch('holidayPeriods/update', this.editForm).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('admin.holidayPeriods.updateSuccess')
            });
            this.dialogVisible = false;
            this.$store.dispatch('holidayPeriods/search');
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
    canEditEffectiveDate() {
      return this.currentRow.effectiveDate && new Date(this.currentRow.effectiveDate) > new Date();
    },
  }
};
</script>
